<template>
  <Layout :class="[prefixCls,'government','blurElementTheme']" v-bind="lockEvents">
    <LayoutFeatures />
    <LayoutHeader :showLogo="getShowLogo"  :triggerMenuFlag="true" :settingLayout="settingLayout"/>
    <Layout :class="[layoutClass]">
      <LayoutSideBar v-if="singlePageFlag!==true&&(getShowSidebar || getIsMobile)" />
      <Layout :class="`${prefixCls}-main`">
        <LayoutMultipleHeader :showHeaderFlag="false" :appLogoFlag="appLogoFlag" v-if="singlePageFlag!==true" :settingLayout="settingLayout" />
        <LayoutContent :analysisSet="analysisSet" />
        <LayoutFooter />
      </Layout>
    </Layout>
  </Layout>
</template>

<script lang="ts">
import {defineComponent, computed, unref} from 'vue';
import { Layout } from 'ant-design-vue';
import { createAsyncComponent } from '@/utils/factory/createAsyncComponent';

import LayoutHeader from '../../default/header/index.vue';
import LayoutContent from '../../default/content/index.vue';
import LayoutSideBar from '../../default/sider/index.vue';
import LayoutMultipleHeader from '../../default/header/MultipleHeader.vue';

import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
import { useDesign } from '@/hooks/web/useDesign';
import { useLockPage } from '@/hooks/web/useLockPage';

import { useAppInject } from '@/hooks/web/useAppInject';
import {usePageFlush} from "@/hooks/setting/usePageFlush";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {MenuModeEnum, MenuTypeEnum} from "@/enums/menuEnum";

export default defineComponent({
  name: 'government',
  components: {
    LayoutFeatures: createAsyncComponent(() => import('@/layouts/default/feature/index.vue')),
    LayoutFooter: createAsyncComponent(() => import('@/layouts/default/footer/index.vue')),
    LayoutHeader,
    LayoutContent,
    LayoutSideBar,
    LayoutMultipleHeader,
    Layout,
  },
  props:{
    analysisSet:{},
    singlePageFlag:{},
    appLogoFlag:{
      type:Boolean,
      default:false
    },
    settingLayout:{}
  },
  setup(props) {
    const { prefixCls } = useDesign('default-layout');
    const { getIsMobile } = useAppInject();
    const { getShowFullHeaderRef } = useHeaderSetting();
    const { getShowSidebar, getIsMixSidebar, getShowMenu } = useMenuSetting();
    const { getShowLogo } = useRootSetting();

    baseHandler(HandlerEnum.CHANGE_LAYOUT, {
      mode: MenuModeEnum.INLINE,
      type: MenuTypeEnum.SIDEBAR,
      split: false,
    });

    //刷新界面的hook
    usePageFlush();
    // Create a lock screen monitor
    const lockEvents = useLockPage();

    const layoutClass = computed(() => {
      let cls: string[] = ['ant-layout'];
      if (unref(getIsMixSidebar) || unref(getShowMenu)) {
        cls.push('ant-layout-has-sider');
      }
      return cls;
    });

    onMounted(()=>{
      const oldClassName=document.body.className;
      if(!((oldClassName+'').indexOf('defaultFrame-body')>=0)){
        document.body.className=document.body.className+" defaultFrame-body";
      }
    })
    return {
      getShowLogo,
      singlePageFlag:unref(props).singlePageFlag,
      appLogoFlag:unref(props).appLogoFlag,
      getShowFullHeaderRef,
      getShowSidebar,
      prefixCls,
      getIsMobile,
      getIsMixSidebar,
      layoutClass,
      lockEvents,
    };
  },
});

</script>
<style lang="less">
@import './less/government.less';
.analysisSet{
  .vben-layout-mix-sider-menu-list{
    position: absolute !important;
  }
}
.xmDefaultFrame.defaultFrame-body{
  #main_router_view_running{
    .vben-layout-mix-sider{
      .vben-app-logo{
        padding-left: 20px !important;
        img {
          margin-right: 12px !important;
        }
      }
    }
  }
  .mini{
    .vben-app-logo{
      padding-left: 8px !important;
    }
  }
}

@prefix-cls: ~'@{namespace}-default-layout';

.@{prefix-cls} {
  display: flex;
  width: 100%;
  min-height: 100%;
  background-color: @content-bg;
  flex-direction: column;

  > .ant-layout {
    min-height: 100%;
  }

  &-main {
    width: 100%;
    margin-left: 1px;
  }
}
</style>
